<script>

export default {
  data() {
    return {
      isLoading: false,
      data: {},
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("google-schedule-staff");
    },
    openModal(data) {
      this.isLoading = true;
      this.data = data;
      this.isLoading = false;
      this.$bvModal.show("google-schedule-staff");
    },
  },
};
</script>

<template>
  <div class="mb-2 d-xl-flex">
    <b-modal
      size="lg"
      id="google-schedule-staff"
      centered
      title-class="font-18"
      hide-footer
      title="Googleカレンダーの予定"
    >
      <b-overlay
        rounded
        opacity="0.6"
        spinner-small
        :show="isLoading"
        spinner-variant="primary"
        class="d-inline-block w-100"
      >
        <b-row class="mt-2">
          <div class="d-flex mb-3">
            <label for="titleGoogleSchedule" class="fw-bold custom-lbl">タイトル</label>
            <div class=" w-100">
              <span id="titleGoogleSchedule">{{ data.title }}</span>
            </div>
          </div>
          <div class="d-flex mb-3">
            <label class="custom-lbl fw-bold">日時</label>
            <b-row>
              <b-col>
                <div class="custom-datepicker">
                  <div class="input-control">
                    <span>{{ data.start_date + ' ' + data.start_hour }}</span>
                  </div>
                </div>
              </b-col>
              <b-col cols="1"class="split d-flex justify-content-center">
                <span>～</span>
              </b-col>
              <b-col>
                <div class="custom-datepicker">
                  <div class="input-control">
                    <span>{{ data.end_date + ' ' + data.end_hour }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="d-flex mb-3">
            <label for="contentGoogleSchedule" class="custom-lbl fw-bold">内容</label>
            <span id="contentGoogleSchedule" v-html="data.content"/>
          </div>
        </b-row>
        <div class="d-flex justify-content-center mt-2">
          <b-button
            variant="primary"
            @click="closeModal"
          >
            {{ this.$lang.button.back }}
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.custom-lbl {
  flex: 0 0 90px;
}
</style>
